import React from "react";
import "./style.scss";

export enum FillType {
  primaryFill = "primaryFill",
  primaryEmpty = "primaryEmpty",
  dangerFill = "dangerFill",
  dangerEmpty = "dangerEmpty",
}

export enum ButtonSize {
  sizeXS = "sizeXS",
  sizeS = "sizeS",
  sizeM = "sizeM",
  sizeL = "sizeL",
  sizeXL = "sizeXL",
}

export enum ButtonType {
  Submit = "submit",
  Button = "button",
}

export type ButtonProps = {
  label?: string;
  type?: ButtonType;
  fillType?: FillType;
  buttonSize?: ButtonSize;
  onClick?: () => void;
  disabled?: boolean;
};

export const Button = (props: ButtonProps) => {
  const { label, type, fillType, buttonSize, onClick, disabled } = props;
  return (
    <button
      type={type ? type : ButtonType.Button}
      className={`buttons ${fillType} ${buttonSize}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};
